import { DictionaryItem } from './common';
import { CampaignType, GroupType } from './domain';
import { GdStringDictName } from './graphql-grid';

export type GroupId = string;

export enum SmartGroupBudgetCalculation {
    AUTO = 'auto',
    FULL = 'full',
    CPC = 'cpc'
}

export enum GdAdGroup {
    GdCpmAudioAdGroup = 'GdCpmAudioAdGroup',
    GdCpmBannerAdGroup = 'GdCpmBannerAdGroup',
    GdCpmGeoproductAdGroup = 'GdCpmGeoproductAdGroup',
    GdCpmIndoorAdGroup = 'GdCpmIndoorAdGroup',
    GdCpmOutdoorAdGroup = 'GdCpmOutdoorAdGroup',
    GdCpmVideoAdGroup = 'GdCpmVideoAdGroup',
    GdDynamicAdGroup = 'GdDynamicAdGroup',
    GdInternalAdGroup = 'GdInternalAdGroup',
    GdMcBannerAdGroup = 'GdMcBannerAdGroup',
    GdMobileContentAdGroup = 'GdMobileContentAdGroup',
    GdSmartAdGroup = 'GdSmartAdGroup',
    GdTextAdGroup = 'GdTextAdGroup'
}

export interface TypeModeGroup {
    groupType: GroupType;
    restrictionId: string;
}
export interface TypeModeGroupItems {
    val: string;
    text: string;
    hidden?: boolean;
    groupType: GroupType;
}

export enum SmartGroupPerformanceFilterType {
    CATEGORIES = 'categories',
    CONDITIONS = 'conditions'
}

export enum DuplicateRadioControlType {
    ACTUAL_CAMPAIGN = 'ACTUAL_CAMPAIGN',
    ANOTHER_CAMPAIGN = 'ANOTHER_CAMPAIGN'
}

export interface DuplicateItem {
    groupName: string;
    campaignName: string;
    groupId: string;
    campaignId: string;
    isInvalid: boolean;
    isDisabled: boolean;
    campaignType: CampaignType;
}

export enum DuplicateGroupsModalViewState {
    duplicate = 'copy',
    selectCampaign = 'selectCampaign'
}

export interface DuplicateValidationResults {
    copyErrorLimitIdxList: string[];
    copyErrorsBrokenGroupsIdxList: string[];
}

export enum GroupsScreenUrlSearchQueryParams {
    campaignsIds = 'campaigns-ids',
    groupsIds = 'groups-ids',
    isNew = 'is-new',
    isNewEmptyGroup = 'is-new-empty-group',
    ulogin = 'ulogin'
}

export enum BannersEditMassActionItemType {
    turbo = 'turbo',
    tracking = 'tracking',
    visibleDomain = 'visibleDomain',
    visibleLinkReplace = 'visibleLinkReplace',
    textPathReplace = 'textPathReplace',
    link = 'link',
    linkReplace = 'linkReplace',
    ageLimit = 'ageLimit',
    childAgeLimit = 'childAgeLimit',
    callouts = 'callouts',
    video = 'video',
    image = 'image',
    videoCreative = 'videoCreative',
    cpmVideoCreative = 'cpmVideoCreative',
    audioCreative = 'audioCreative',
    siteLinks = 'siteLinks',
    bannerPrice = 'bannerPrice',
    imageCreative = 'imageCreative',
    cpmImageCreative = 'cpmImageCreative',
    counters = 'counters',
    pixel = 'pixel'
}

export enum GroupsEditMassActionItemType {
    minusPhrase = 'minusPhrase'
}

export interface BannersEditMassActionItem {
    type: BannersEditMassActionItemType;
    text: React.ReactNode;
    val: string;
    disabled?: boolean;
    hidden?: boolean;
}

export type BannersEditMassActionGroup = {
    title?: string;
    items: Array<BannersEditMassActionItem>;
};

export type BannersEditMassActionItems = Array<BannersEditMassActionGroup>;

export type StringDictsItems = Partial<
    Record<GdStringDictName, DictionaryItem[]>
>;

export interface GroupsEditMassActionItem {
    type: GroupsEditMassActionItemType;
    text: React.ReactNode;
    val: string;
    disabled?: boolean;
    hidden?: boolean;
}

export type GroupsEditMassActionGroup = {
    title?: string;
    items: Array<GroupsEditMassActionItem>;
};

export type GroupsEditMassActionItems = Array<GroupsEditMassActionGroup>;
